import * as React from 'react'
import {observer} from 'mobx-react-lite'
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import FormHelperText from "@material-ui/core/FormHelperText";
import Suggestion from "./Suggestion";
import {useTranslation} from "react-i18next";




export default observer(({
                             field, translationPrefix,
                             className,
                             InputLabelProps,
                             margin,
                             fullWidth,
                             suggestion,
                             suggestionPrefix,
                             ...rest
                         }) => {
    const applySuggestion = ()=>{
        field.onChange(suggestion)
    }

    const {t} = useTranslation(translationPrefix);


    return (
        <FormControl fullWidth={fullWidth} margin={margin} className={className}>
            <InputLabel error ={!suggestion && field.error} {...InputLabelProps} >{t(field.label)}</InputLabel>
            <Input
                type={field.type || "text"}
                {...field.bind()}
                {...rest}
            />
            <FormHelperText error ={!suggestion && field.error} >
                {suggestion
                    ? ( <Suggestion suggestion={suggestion} suggestionPrefix={suggestionPrefix} onApply={applySuggestion} /> )
                    : (field.error)  }
            </FormHelperText>
        </FormControl>
    )
})